import { render, staticRenderFns } from "./DeleteAppointmentDialog.vue?vue&type=template&id=c42da166&"
import script from "./DeleteAppointmentDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteAppointmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports